import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Button,
  Link,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Fade,
  Chip,
} from '@mui/material';
import {
  Global,
  People,
  CallCalling,
  MessageText1,
  Location,
  Sms,
  Share,
  MoreCircle,
  RepeatCircle,
  Lock,
  Eye,
  AddCircle,
  UserAdd,
  UserMinus,
  CloseCircle,
  TickCircle,
} from 'iconsax-react';
import styles from '../cards/cards.module.scss';
import {
  getNameFromProfileOptions, getPhoneNumberWihKey,
} from '../../utils/profile-utils';
import NFCIcon from '../../icons/nfc.png';
import ShareModal from '../cards/share-modal';
import QRModal from '../cards/qr-modal';
import { SocialIcon } from 'react-social-icons';
import { LoadingButton } from '@mui/lab';
import SyncModal from '../view-card/sync-modal';
import RemoveCardModal from '../shared/remove-card-modal';
import ViewImgModal from '../../my-data/category/view-img-modal';

const ContactCard = ({ card, settings, uiStore, defaultCard, update, contacts }) => {
  const [flipCard, setFlipCard] = useState(false);
  const [name, setName] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [department, setDepartment] = useState('');
  const [company, setCompany] = useState('');
  const [location, setLocation] = useState({ lat: 10, lng: 10, zoom: 1 });
  const [anchorEl, setAnchorEl] = useState(null);
  const [isPublic, setPublic] = useState(card?.isPublic);
  const [loading, setLoading] = useState(false);
  const [connected, setConnected] = useState(false);
  const [followed, setFollowed] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [pending, setPending] = useState(false);
  const [showRemoveCard, setShowRemoveCard] = useState(false);
  const [showImgModal, setShowImgModal] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    let lang = '';
    if (card?.langs?.includes(settings.firstLanguage)) lang = settings.firstLanguage;
    else if (card?.langs?.includes(settings.secondLanguage)) lang = settings.secondLanguage;
    else lang = card?.langs[0];
    let tempName = getNameFromProfileOptions(card, settings.nameFormat, lang);

    setName(tempName);

    if (card?.JobTitle)
      setJobTitle(card?.JobTitle.infoValue[lang]);

    if (card?.Field)
      setJobTitle(card?.Field.infoValue[lang]);

    if (card?.Company)
      setCompany(card?.Company.infoValue[lang]);

    if (card?.Department)
      setDepartment(
        card?.Department.infoValue[lang]
      );

    if (card?.Location) {
      const newLocation = JSON.parse(card?.Location.infoValue);
      setLocation(newLocation);
    }

    setConnected(card?.connected);
    setFollowed(card?.followed);
    setPublic(card?.isPublic);

    if (card?.Nickname && card?.isBasic) setJobTitle(card?.Nickname.infoValue[lang]);
    if (card?.Nickname && !card?.JobTitle && !card?.Field && tempName !== card?.Nickname.infoValue[lang]) setJobTitle(card?.Nickname.infoValue[lang]);

  }, [card, settings]);

  const setDefault = async () => {
    setLoading(true);
    await uiStore.setDefaultCard(card?._id);
    update();
    setLoading(false);
  }

  const toggleFollow = async () => {
    if (followed) {
      setFollowed(false);
      await uiStore.updateFollow(false, card?._id);

    } else {
      setFollowed(true);
      await uiStore.updateFollow(true, card?._id);
    }
  }

  const removeCard = async () => {
    await uiStore.removeCard(card?._id);
    setConnected(false);
    setFollowed(false);
  }

  return (
    <Box className={flipCard ? [styles.card, styles.cardFlipped] : styles.card}>
      <Box className={styles.cardInner}>
        <Box className={styles.cardFront}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box className={styles.cardPublic}>
              {isPublic ? (
                <Tooltip title="Public">
                  <Global size="24" color="black" variant="Bold" />
                </Tooltip>
              ) : (
                <Tooltip title="Private">
                  <Lock size="24" color="black" variant="Bulk" />
                </Tooltip>
              )}
              <Typography fontSize="14px">{card?.name}</Typography>
            </Box>
            <Box className={styles.cardHeader}>
              <People size="24" variant="Bulk" />
              <Typography fontSize="12px" fontWeight="500">
                {card?.connections}
              </Typography>
            </Box>
          </Box>

          <Box className={styles.cardInfo}>
            <Box className={styles.cardImg}>
              <Button onClick={() => setShowImgModal(true)} sx={{ p: 0, overflow: 'hidden', minWidth: 'fit-content' }}>
                <img src={card.image} alt="Pesonal"></img>
              </Button>
            </Box>
            <Box className={styles.cardTitle}>
              <Link
                href={name ? '/card/' + card?._id : '/edit-card/' + card?._id}
                sx={{ textDecorationColor: 'rgba(29, 23, 97, 0)' }}
              >
                <Typography
                  fontSize="16px"
                  fontWeight="600"
                  color="primary"
                  className={styles.cardName}
                >
                  {!name ? <> Click here to select a name</> : name}
                </Typography>
              </Link>
              <Typography fontSize="12px" fontWeight="500">
                {jobTitle}
              </Typography>
              <Typography fontSize="12px" fontWeight="500">
                {department && department}
                {department && company && ' - '}
                {company && '' + company}
              </Typography>
            </Box>
          </Box>

          <Box className={styles.cardActions}>
            <Box>
              {card?.Number && (
                <Tooltip title="Call">
                  <IconButton
                    href={
                      'tel:' + getPhoneNumberWihKey(card?.Number)
                    }
                  >
                    <CallCalling size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
              )}
              {card?.Number?.countryCode && (
                <Tooltip title="Text">
                  <IconButton
                    href={
                      'sms:' + getPhoneNumberWihKey(card?.Number)
                    }
                  >
                    <MessageText1 size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
              )}
              {card?.Email && (
                <Tooltip title="Email">
                  <IconButton href={'mailto:' + card?.Email.infoValue}>
                    <Sms size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
              )}
              {card?.Location && (
                <Tooltip title="Location">
                  <IconButton
                    href={`https://www.google.com/maps/search/?api=1&query=${location.lat},${location.lng}`}
                    target="_blank"
                    rel='noopener noreferrer'
                  >
                    <Location size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
              )}
              {card?.Website && (
                <Tooltip title="Website">
                  <IconButton
                    href={card?.Website.infoValue}
                    target="_blank"
                    rel='noopener noreferrer'
                  >
                    <Global size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box className={styles.cardSecActions}>
              {!flipCard && !!card?.socials.length && (
                <>
                  <Tooltip title="Socials">
                    <IconButton
                      id="basic-button"
                      aria-controls={open ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                    >
                      <Share size="24" variant="Bulk" />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        borderRadius: '8px',
                        width: '150px',
                        boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.07)',
                        paddingTop: 0,
                      },
                    }}
                  >
                    {card?.socials.map(social =>
                      <MenuItem key={social._id} href={social.infoValue} component='a' rel='noopener noreferrer' target="_blank">
                        <ListItemIcon>
                          <SocialIcon network={social.section.name.toLowerCase()} style={{ height: 18, width: 18 }} />
                        </ListItemIcon>
                        <ListItemText
                          primaryTypographyProps={{ fontSize: '14px' }}
                        >
                          {social.section.name}
                        </ListItemText>
                      </MenuItem>
                    )}
                  </Menu>
                </>
              )}

              <Fade in={!flipCard}>
                <Tooltip title="Options">
                  <IconButton onClick={() => setFlipCard(true)}>
                    <MoreCircle size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
              </Fade>
            </Box>
          </Box>
        </Box>

        <Box className={styles.cardBack}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box className={styles.cardPublic}>
              {isPublic ? (
                <Tooltip title="Public">
                  <Global size="24" color="black" variant="Bulk" />
                </Tooltip>
              ) : (
                <Tooltip title="Private">
                  <Lock size="24" color="black" variant="Bulk" />
                </Tooltip>
              )}
              <Typography fontSize="14px">{card?.name}</Typography>
            </Box>

            {contacts &&
              <Box sx={{ mt: 2, mr: 2 }}>
                {defaultCard === card?._id ?
                  <Chip variant='contained' label='Default' icon={<TickCircle variant='Bulk' size={20} />} color='whiteNav' />
                  :
                  <LoadingButton
                    onClick={setDefault}
                    loading={loading}
                    variant='contained'
                    color='primary'
                    sx={{ borderRadius: '16px' }}
                  >
                    <Typography fontSize='0.8125rem'>Set Default</Typography>
                  </LoadingButton>
                }
              </Box>
            }
          </Box>
          <Box className={styles.cardBackActions}>
            <ShareModal cardId={card?._id} />
            <QRModal cardId={card?._id} />
            <Button color="greyPrimary">
              <img src={NFCIcon} alt="Share" />
              NFC
            </Button>
          </Box>
          <Box className={styles.cardActions}>
            <Box>
              <Tooltip title="View">
                <IconButton href={'/card/' + card?._id}>
                  <Eye size="24" variant="Bulk" />
                </IconButton>
              </Tooltip>
              {card?.allowSyncing && !pending && <>{connected ?
                <Tooltip title="Remove Card">
                  <IconButton onClick={() => setShowRemoveCard(true)}>
                    <CloseCircle size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
                :
                <Tooltip title="Add Card">
                  <IconButton onClick={() => setShowSyncModal(true)}>
                    <AddCircle size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
              }</>}
              {card?.allowFollowing && <>{followed ?
                <Tooltip title="Unfollow">
                  <IconButton onClick={toggleFollow}>
                    <UserMinus size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
                :
                <Tooltip title="Follow">
                  <IconButton onClick={toggleFollow}>
                    <UserAdd size="24" variant="Bulk" />
                  </IconButton>
                </Tooltip>
              }</>}

            </Box>
            <Box>
              <Tooltip title="Back">
                <IconButton onClick={() => setFlipCard(false)}>
                  <RepeatCircle size="24" variant="Bulk" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </Box>
      </Box>

      <SyncModal show={showSyncModal} setShow={setShowSyncModal} uiStore={uiStore} cardId={card?._id} setPending={setPending} />
      <RemoveCardModal show={showRemoveCard} setShow={setShowRemoveCard} card={card} removeCard={removeCard} />
      <ViewImgModal img={card?.image} show={showImgModal} setShow={setShowImgModal} />

    </Box >
  );
};

export default ContactCard;
